import type { StyleRule } from '@archipro-design/aria';
import { gridClassName, pxArrayToRem, pxToRem } from '@archipro-design/aria';

export const Associations: StyleRule = ({ theme }) => ({
    [`& .${gridClassName}`]: {
        padding: pxArrayToRem([16, 0, 15, 0]),
        gap: theme.siteVariables.spaces['space-12'],
    },
    [theme.screen.laptop]: {
        [`& .${gridClassName}`]: {
            padding: 0,
            columnGap: pxToRem(14),
        },
    },
});

export const Association: StyleRule = ({ theme }) => ({
    width: pxToRem(40),
    height: pxToRem(40),
    borderRadius: '50%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '74%',
    [theme.screen.laptop]: {
        width: pxToRem(40),
        height: pxToRem(40),
    },
});
